<template>
    <div class="story-maker-sticker story-maker-sticker-music" :class="{edit : isSelected}">
        
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">{{ $t('dash.post-creator.story.done') }}</p>
        <i class="fa-solid fa-trash trash" @click="deleteMusic"></i>

        <div 
            class="sticker sticker-music"
        >

        <template v-if="stickerInstance.data.styleVariant">
           <div v-if="stickerInstance.data.styleVariant == 1" class="card-style">
                <img :src="stickerInstance.data.music.track ? stickerInstance.data.music.track.cover_artwork_thumbnail_uri : stickerInstance.data.music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false">
                <div class="info-music">
                    <p class="name">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.title : stickerInstance.data.music.original_sound.original_audio_title }}</p>
                    <p class="author">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.display_artist : stickerInstance.data.music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>

           <div v-else-if="stickerInstance.data.styleVariant == 2"  class="square-style">
                <div class="image">
                    <img :src="stickerInstance.data.music.track ? stickerInstance.data.music.track.cover_artwork_thumbnail_uri : stickerInstance.data.music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false"></img>
                    <div class="sound-effect"></div>
                </div>
               
                <div class="info-music">
                    <p class="name">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.title : stickerInstance.data.music.original_sound.original_audio_title }}</p>
                    <p class="author">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.display_artist : stickerInstance.data.music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>

            <div v-else-if="stickerInstance.data.styleVariant == 3" class="disc-style">
                <div class="disc">
                    <img :src="stickerInstance.data.music.track ? stickerInstance.data.music.track.cover_artwork_thumbnail_uri : stickerInstance.data.music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false"></img>
                </div>
               
                <div class="info-music">
                    <p class="name">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.title : stickerInstance.data.music.original_sound.original_audio_title }}</p>
                    <p class="author">{{stickerInstance.data.music.track ? stickerInstance.data.music.track.display_artist : stickerInstance.data.music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>
        </template>

        </div>

        <div class="container-options" v-if="isSelected">
            <div class="styles" v-if="false">
                <div :class="['style', `${value}-style`, {active: index == stickerInstance.data.styleVariant}]" @click="changeStyleVariant(index)" v-for="(value, index) in ['empty','card', 'square','disc']"></div>
            </div>
            <CursorMusic 
                :music="stickerInstance.data.music"
                :defaultRangeDuration="stickerInstance.duration"
                :defaultStart="stickerInstance.data.start"
                :durationLock="!stickerInstance.durationIsEditable ? stickerInstance.duration : null"
                @rangeDurationChange="stickerInstance.data.duration = parseInt($event)"
                @startChange="stickerInstance.data.start = $event"
            />
        </div>
        <!-- <div class="sticker-music">
           <div class="icon"></div>
            {{ music.track.title ? music.track.title : '' }}
        </div> -->
    </div>
</template>

<script>

import CursorMusic from '../../../cursorMusic.vue';
import { EventBus } from '@/event-bus';

export default {
    components: {
        CursorMusic,
    },
    props: {
        id: Number | String,
        isSelected: Boolean,
        stickerInstance: {
            type: Object,
            required: true
        },
    },
    
    data() {
        return {        
        }
    },

    mounted () {
    },

    methods: {

        finish() {
            this.$emit('unselect')
        },

        changeStyleVariant(index) {
            this.stickerInstance.data.styleVariant = index
        },

        deleteMusic() {
            this.$emit('deleteSticker')
        }
    },


}
</script>
